<div  class="outside-container mt-4">
    <div class="box-container ">
        <div class="container">
          <div class="title">
          <div class="row">
            <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
           <div class="col-md-7 d-flex justify-content-center">Raise Ticket</div>
           <div class=" col-md-3 row ">
             <div class="d-flex justify-content-end">
              <!-- <button *ngIf="showCredit" class="btn btn-outline-primary btn-sm " ><img src="assets/images/Add_24.png"></button> -->
             
           </div>
            </div>
          </div>
        </div>
</div>
</div>
</div>
<div  class="outside-container ">
    <div class="box-container ">
        <div class="container">

            <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
               
               
                <div class="col-md-2  "  style="background-color: #d2e1f5; border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                  <div class="col-md-12 ">
                    <!-- [ngClass]="{'activity' :showItinerary}" -->
                  <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="onAirClick()" [ngClass]="{'activity' :showAir}" >AIR</span></span>
                  <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"     >HOTEL</span></span>
                
                  
                </div>
</div>


<div class="col-md-10  ">
<div class="col-md-12 card" style="height: 100%;">
    <div *ngIf="showAir" class="col-md-12 " style="padding: 20px;">
    <form  autocomplete="off"  class=" row col-md-12 ">

        <!-- <form   autocomplete="off"  class=" col-md-12 row"> -->
            <mat-form-field class="col-md-6" appearance="outline">
                <mat-label >Subject</mat-label>
                <input matInput type="text" required  [(ngModel)]="ticket.title" [ngModelOptions]="{standalone: true}" >              
              </mat-form-field>
              <mat-form-field class="col-md-6" appearance="outline">
                <mat-label>Reference Request Id</mat-label>
                <input matInput type="text"  [(ngModel)]="ticket.requestId" [ngModelOptions]="{standalone: true}" >              
              </mat-form-field>
             
           
               
                
                  <!-- (change)="onFileSelected($event)" -->
             
              
            <mat-form-field class="col-md-12" appearance="outline" >
                <mat-label>Description</mat-label>

                <textarea matInput required name="" id="" cols="1" rows="5" [(ngModel)]="ticket.description" [ngModelOptions]="{standalone: true}"></textarea>             

                </mat-form-field>
                <mat-form-field class="col-md-6" appearance="outline">
                  <mat-label>Reference Cart Id</mat-label>
                  <input matInput type="text"  [(ngModel)]="ticket.CartId" [ngModelOptions]="{standalone: true}" >              
                </mat-form-field>
                <mat-form-field class="col-md-6" appearance="outline">
                    <mat-label>Error Screen Shot</mat-label>
    
                    <input matInput  readonly [value]="fileName">
                    <button mat-flat-button color="primary" matSuffix (click)="fileInput.click()">Browse</button>
                    <input type="file" accept="image/*" #fileInput (change)="onFileSelected($event)"  hidden>
                  </mat-form-field>
                <div  class=" col-md-12  d-flex justify-content-end" >
                    <button  *ngIf="Disabled()&&!disabled"  mat-flat-button  style="width: auto; height: 55px; color: white; background-color: #1e8f5a;; margin-right: 8px;font-weight: bold;"  (click)="onSubmit()" >Submit </button>
                    <button *ngIf="!Disabled()||disabled"   mat-flat-button  style="width: auto; height: 55px; color: white; background-color: #84b29d;; margin-right: 8px;font-weight: bold;"  >Submit </button>
    
                </div>
            </form>
            <!-- <p-editor [(ngModel)]="text" [style]="{ height: '320px' }">
               <ng-template #header>
                  <span class="ql-formats">
                      <button type="button" class="ql-bold" aria-label="Bold"></button>
                      <button type="button" class="ql-italic" aria-label="Italic"></button>
                      <button type="button" class="ql-underline" aria-label="Underline"></button>
                  </span>
              </ng-template> 
          </p-editor>
          <p-editor formControlName="text" [style]="{ height: '320px' }" /> 
<button (click)="onClick()">hello</button> -->
          
            
        </div>
        </div>


    
  </div>

  <div class="ticket-list">
    <ul>
      <li *ngFor="let ticket of tickets">
        <h3>{{ ticket.title }}</h3>
        <p>{{ ticket.description }}</p>
        <span>Priority: {{ ticket.priority }}</span>
      </li>
    </ul>
  </div>
  